// extracted by mini-css-extract-plugin
export default {"result-title":"_result-title_7hKV1I","result-descr":"_result-descr_Kv7ISc"};